module.exports = __webpack_public_path__ + "img/antenna.9d73b39f.svg";